/* eslint-disable @typescript-eslint/no-unused-vars */
import React, {useState} from 'react';
import styles from './UserListTable.module.scss';
import {Popover, Table, TableColumnsType} from "antd";
import {User} from "../../../types/User";
import {VerifyStatusType} from "../../../types/Type";
import {getVerificationTag} from "../UserListPanel/UserListPanel";
import userAPI from "../../../api/userAPI";

interface UserListTableProps {
	list: User[];
	onClickRow: (data: User) => any;
}

const UserListTable = ({ list, onClickRow }: UserListTableProps) => {
	const [openPopover, setOpenPopover] = useState<{ type: 'balju' | 'suju'; baechaId: string } | null>(null);
	const [popupData, setPopupData] = useState<any>(undefined);

	const shadedCell = { style: {backgroundColor: '#f5f5f5'} };

	const onOpenPopup = async (bool: boolean, type: 'balju' | 'suju', baechaId: string, userId?: string) => {
		if (bool && userId) {
			const res = await userAPI.fetchUserDataAPI(userId);
			setPopupData(res);
			setOpenPopover({ type, baechaId });
		} else {
			setPopupData(undefined);
			setOpenPopover(null);
		}
	};

	const onClosePopup = (e: any) => {
		e.preventDefault();
		setOpenPopover(null);
		setPopupData(undefined);
	};

	const columns: TableColumnsType<User> = [
		{
			title: '이름',
			key: 'name',
			dataIndex: 'name',
			align: 'center',
			width: 70,
			onCell: () => ({ style: { position: 'relative', padding: 0 } }),
			render: (value: any, record: User, index: number) => (
				<Popover
					placement="top"
					content={(
						<a onClick={onClosePopup}>
							{popupData?.memberInfo?.filter((item: any) => item.status === 'ok').length > 0 && (
								<div>
									{popupData?.memberInfo?.filter((item: any) => item.status === 'ok')
										.map((item: any) => <div key={item.name}>{item.name}</div>)}
								</div>
							)}
						</a>
					)}
					trigger="click"
					title={(
						<div style={{ display: 'flex', justifyContent: 'space-between' }}>
							<div>{popupData?.userInfo?.name || ''}</div>
							<div>{popupData?.userInfo?.phoneNum || ''}</div>
						</div>
					)}
					open={openPopover?.type === 'balju' && openPopover?.baechaId === record.id}
					onOpenChange={(bool, e) => {
						e?.stopPropagation();
						onOpenPopup(bool, 'balju', record.id, record.id)
					}}
				>
					<div className={styles.clickable} onClick={(e) => e.stopPropagation()}>
						{value}
					</div>
				</Popover>
			),
		},
		{
			title: '전화번호',
			key: 'phoneNum',
			dataIndex: 'phoneNum',
			align: 'center',
			width: 50,
		},
		{
			title: '이메일',
			key: 'email',
			dataIndex: 'email',
			align: 'center',
			width: 60,
		},
		{
			title: (
				<>
					<div>사업자등록증</div>
					<div>인증 여부</div>
				</>
			),
			key: 'businessStatus',
			dataIndex: 'businessStatus',
			align: 'center',
			width: 50,
			render: (text: VerifyStatusType) => getVerificationTag(text),
		},
		{
			title: (
				<>
					<div>차량 인증 여부</div>
					<div>(심사 / 거부 / 미인증 / 인증)</div>
				</>
			),
			key: 'carVerification',
			width: 100,
			align: 'center',
			render: (value: any) => {
				const tag = +value.reviewCount > 0
					? getVerificationTag('review')
					: +value.rejectedCount > 0
						? getVerificationTag('rejected')
						: +value.verifiedCount === 0
							? ''
							: +value.verifiedCount === +value.reviewCount + +value.rejectedCount + +value.verifiedCount
								? getVerificationTag('verified')
								: '';

				return (
					<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
						<div>{tag}</div>
						<div>{`(${value.reviewCount} / ${value.rejectedCount} / ${value.unverifiedCount} / ${value.verifiedCount})`}</div>
					</div>
				);
			}
		},
		{
			title: (
				<div>
					<div>사업자</div>
					<div>등록 번호</div>
				</div>
			),
			key: 'invoiceeCorpNum',
			dataIndex: 'invoiceeCorpNum',
			align: 'center',
			width: 50,
			onCell: () => shadedCell,
		},
		{
			title: '회사명',
			key: 'invoiceeCorpName',
			dataIndex: 'invoiceeCorpName',
			align: 'center',
			width: 100,
			onCell: () => shadedCell,
		},
		{
			title: '대표명',
			key: 'invoiceeCeoName',
			dataIndex: 'invoiceeCeoName',
			align: 'center',
			width: 80,
			onCell: () => shadedCell,
		},
		{
			title: '업태',
			key: 'invoiceeBizType',
			dataIndex: 'invoiceeBizType',
			align: 'center',
			width: 80,
			onCell: () => shadedCell,
		},
		{
			title: '주소',
			key: 'invoiceeAddr',
			dataIndex: 'invoiceeAddr',
			align: 'center',
			width: 200,
			onCell: () => shadedCell,
		},
	];

	return (
		<Table
			bordered
			columns={columns}
			dataSource={list.map((row) => ({...row, key: row.id}))}
			rowKey="id"
			size="small"
			scroll={{x: 'max-content'}}
			pagination={false}
			onRow={(record) => {
				return {
					onClick: () => onClickRow(record),
					style: {cursor: 'pointer'},
				}
			}}
		/>
	);
};

export default UserListTable;
